import { type ReactNode } from "react";
import { ConvexProvider } from "convex/react";
import { ConvexBetterAuthProvider } from "@convex-dev/better-auth/react";
import { ThemeProvider } from "next-themes";
import { Toaster } from "./ui/sonner";

import { authClient } from "@/lib/auth-client";
import { convex } from "@/lib/convex";
import { LocaleProvider } from "@/lib/i18n";

interface ProvidersProps {
  children: ReactNode;
}

export function Providers({ children }: ProvidersProps) {
  return (
    <LocaleProvider>
      <ThemeProvider
        attribute="class"
        defaultTheme="system"
        disableTransitionOnChange
        enableSystem
        storageKey="theme"
      >
        <ConvexProvider client={convex}>
          <ConvexBetterAuthProvider client={convex} authClient={authClient}>
            {children}
            <Toaster />
          </ConvexBetterAuthProvider>
        </ConvexProvider>
      </ThemeProvider>
    </LocaleProvider>
  );
}
